import { ApiProperty } from '@nestjs/swagger'
import { Time } from '../../settings'

export const SLOT_OCCUPANCY_LEVELS = ['low', 'medium', 'high'] as const

/** Demand level of a slot, derived only from real bookings — never fabricated. */
export type SlotOccupancy = (typeof SLOT_OCCUPANCY_LEVELS)[number]

export class TimeSlot {
	@ApiProperty({ type: () => Time })
	time: Time

	@ApiProperty({ type: Boolean })
	available: boolean

	@ApiProperty({ enum: SLOT_OCCUPANCY_LEVELS })
	occupancy: SlotOccupancy

	/**
	 * Among the historically most requested times of this day (relative to the
	 * restaurant's own past bookings) — independent of today's live occupancy.
	 */
	@ApiProperty({ type: Boolean })
	popular: boolean

	/**
	 * House recommendation: the earliest quiet slots of each shift. Steers
	 * guests toward early times and spreads the load away from the peak.
	 */
	@ApiProperty({ type: Boolean })
	recommended: boolean
}
